const MAX_EDGE = 1000;
const JPEG_QUALITY = 0.82;

/**
 * Shrinks a photo from the camera to at most MAX_EDGE pixels on its long side, as a JPEG.
 * Phone photos are several MB; the server takes 1 MB, and a bottle thumbnail needs far less.
 */
export async function shrinkPhoto(file: Blob): Promise<Blob> {
  const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  try {
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Could not process the photo.');
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Could not process the photo.'))), 'image/jpeg', JPEG_QUALITY);
    });
  } finally {
    bitmap.close();
  }
}
